import { render, staticRenderFns } from "./_evolive.vue?vue&type=template&id=56cc11f8&lang=pug&"
import script from "./_evolive.vue?vue&type=script&lang=js&"
export * from "./_evolive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports